/**
 * Constantes visuais compartilhadas pelos gráficos Recharts do Painel
 * Executivo. Cor sempre por variável CSS de tema (nunca hex fixo), para
 * responder ao tema claro/escuro — CLAUDE.md, "Regras de interface", item 2.
 */

export const RISCA_GRADE = 'hsl(var(--border))';

export const ROTULO_EIXO = {
  fontSize: 11,
  fill: 'hsl(var(--muted-foreground))',
};

export const ESTILO_TOOLTIP: React.CSSProperties = {
  background: 'hsl(var(--popover))',
  border: '1px solid hsl(var(--border))',
  borderRadius: '12px',
  fontSize: '12px',
  color: 'hsl(var(--popover-foreground))',
  boxShadow: '0 4px 20px -4px hsl(var(--foreground) / 0.1)',
};

export const PROPS_TOOLTIP = {
  contentStyle: ESTILO_TOOLTIP,
  labelStyle: { color: 'hsl(var(--popover-foreground))', fontWeight: 600 },
  itemStyle: { color: 'hsl(var(--popover-foreground))' },
};

/** Paleta categórica para gráficos de pizza — tokens de tema, nunca hex fixo. */
export const CORES_FATIA = [
  'hsl(var(--primary))',
  'hsl(var(--success))',
  'hsl(var(--orange))',
  'hsl(var(--destructive))',
  'hsl(var(--info))',
  'hsl(var(--accent))',
];
